export default {
	"users_register": {
        "registerPhone": "手機註冊",
        "registerEmail": "郵箱註冊",
        "hasAccount": "已有帳號？",
        "agree": "我同意",
        "agreement": "使用者協定",
        "and": "和",
        "policy": "隱私政策",
        "logoutNotice": "永久刪除帳戶",
        "submit": "提交",
        "selectArea": "選擇常住地區",
        "countryOrRegion": "國家/地區",
        "change": "更換",
        "defaultRegion": "中國內地",
        "AE": "阿拉伯聯合酋長國",
        "search": "搜索熱門國家/地區",
        "reminder": "溫馨提示",
        "reminderTips": "選擇【",
        "reminderTips2": "】作為常駐地區，可享受該地區及周邊的專享優惠。選定後將不可更改。確定選擇嗎？",
        "confirm": "確定",
        "cancel": "取消",
        "setPassword": "設置密碼",
        "registerByEmail": "請點擊其中的連結來完成您的帳戶註冊。",
        "activeSuc": "啟動成功",
        "activeing": "正在激活",
        "activeAgain": "再次激活",
        "activeFail": "激活失敗",
        "verified": "我已驗證",
        "registerSuccess": "註冊成功"
    },
    "users_login": {
        "loginPhone": "手機登錄",
        "loginEmail": "郵箱登錄",
        "register": "帳號註冊",
        "inputPhone": "請輸入手機號碼",
        "inputPassword": "請輸入密碼",
        "forgetPassword": "忘記密碼",
        "login": "登錄",
        "goToLogin": "去登陸",
        "inputEmail": "請輸入郵箱號",
        "smsCode": "短信驗證碼",
        "inputSMSCode": "請輸入短信驗證碼",
        "noReceiveCode": "沒收到驗證碼？",
        "resend": "重新發送",
        "nextStep": "下一步",
        "findByPhone": "通過手機找回",
        "findByEmail": "通過郵箱找回",
        "verifyByEmail": "請到郵箱驗證",
        "sendEmailTo": "我們已發送一封電子郵件到",
        "findYourPassword": "請點擊其中的連結，並按步驟操作來找回您的密碼",
        "noReceiveEmail": "收不到郵件？請檢查您的垃圾郵件和已刪除郵件目錄下是否有來自 glocalme@ucloudlink.com 的郵件。",
        "or": "或",
        "resetPassword": "重設密碼",
        "oldFormat": "至少6個字元",
        "passwordFormat": "6-20個字元(字母、數位或符號的組合)",
        "completeLogin": "完成並登錄",
        "resetPasswordSuc": "重設密碼成功",
        "backToGlocalMe": "請回到 GlocalMe Connect 登錄體驗",
        "activeReminder": "帳戶未啟動，請前往該郵箱，點擊啟動連結來完成您的帳戶註冊。",
        "known": "知道了"
    },
    "modify_information": {
        "account": "帳戶",
        "name": "姓名",
        "identification": "護照/身份證號碼",
        "countryName": "常駐地區",
        "id": "身份証資料",
        "edit": "編輯",
        "complete": "完成",
        "placeholderFirstName": "請輸入您的姓氏",
        "placeholderName": "請輸入您的名字",
        "firstName": "姓氏",
        "lastName": "名字",
        "placeholderID": "請輸入您的身份證/VISA卡/駕駛號碼",
        "isNull": "未填寫",
        "onlyNumber": "只能輸入數位或字母",
        "IDTip": "只能輸入數位或字母"
    },
    "route.email":"郵箱註冊",
    "route.mobilephone":"手機註冊",
    "register.Rplace":"請選擇註冊地",
    "register.Uagreement":"請同意用戶協議",
    "register.UnhaveAccount":"賬號未輸入",
    "register.AccountError":"賬號格式不對",
    "register.RegisterChannel":"註冊渠道",
}


// WEBPACK FOOTER //
// ./src/lang/tw/register.js